function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { defineStore } from 'pinia';
import { FacetGroupRepositoryJson } from '~/apps/facets/repository/facet-groups/FacetGroupRepositoryJson';
export var useFacetsStore = defineStore('facetsStore', () => {
  var router = useRouter();
  var route = router.currentRoute;
  var lang = route.params.lang || 'en-gb';
  var repo = new FacetGroupRepositoryJson();
  var facetGroups = ref(null);
  function getFacetGroups(_x) {
    return _getFacetGroups.apply(this, arguments);
  } // if store used for a component that was ssr this will be available
  // so putting it in layout
  function _getFacetGroups() {
    _getFacetGroups = _asyncToGenerator(function* (lang) {
      facetGroups.value = yield repo.getFacetGroups(lang);
    });
    return _getFacetGroups.apply(this, arguments);
  }
  onServerPrefetch( /*#__PURE__*/_asyncToGenerator(function* () {
    yield getFacetGroups(lang);
  }));
  // if the facets weren't loaded ssr by chance, then load them on client
  onBeforeMount( /*#__PURE__*/_asyncToGenerator(function* () {
    if (!facetGroups.value) yield getFacetGroups(lang);
  }));
  var facetsBySlug = computed(() => {
    if (!facetGroups.value) return {};
    return facetGroups.value.reduce((acc, group) => {
      group.facets.forEach(facet => {
        acc[facet.slug] = facet;
      });
      return acc;
    }, {});
  });
  return {
    facetGroups,
    facetsBySlug
  };
});